module.exports = __webpack_public_path__ + "img/yoga-set.87ae9fe3.jpg";